import { render } from "./YourResultsSection.vue?vue&type=template&id=5d5fb769&scoped=true"
import script from "./YourResultsSection.vue?vue&type=script&lang=js"
export * from "./YourResultsSection.vue?vue&type=script&lang=js"

import "./YourResultsSection.vue?vue&type=style&index=0&id=5d5fb769&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d5fb769"]])

export default __exports__